<div class="left-side">
  <sn-avatar
    class="left-side__avatar"
    size="32"
    *ngIf="!inherited && !isSystemMessage"
    [name]="author?.fullName || message.twilio.attributes.authorFriendlyName"
  >
  </sn-avatar>

  <sn-icon
    *ngIf="message.extMessage && !inherited"
    class="ext-icon"
    fontSet="fa-regular"
    fontIcon="fa-arrows-repeat"
  ></sn-icon>

  <sn-message-timestamp
    class="left-side__time"
    *ngIf="inherited || isSystemMessage"
    [message]="message"
  >
  </sn-message-timestamp>
</div>

<sn-message-view
  *ngIf="!isEditing"
  [message]="message"
  [isSystemMessage]="isSystemMessage"
  [author]="author"
  [inherited]="inherited"
>
</sn-message-view>

<sn-message-edit
  *ngIf="isEditing"
  [message]="message"
  (cancel)="onChangesCancel()"
  (save)="onChangesSave($event)"
>
</sn-message-edit>

<sn-icon-button *ngIf="isOwnMessage || isMedia" class="menu" [matMenuTriggerFor]="menu">
  <sn-icon>more_vert</sn-icon>
</sn-icon-button>

<mat-menu #menu="matMenu">
  <sn-menu [items]="menuActions" [context]="message"></sn-menu>
</mat-menu>
